import axios from '@axios'

export default {
    namespaced: true,
    state: {},
    getters: {},
    mutations: {},
    actions: {
        list: (cntx, params) => new Promise((resolve, reject) => {
            axios.get('inline_tags', { params })
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        reclassify: (cntx, params) => new Promise((resolve, reject) => {
            axios.post('grower_tag', params)
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        grades: (cntx, params) => new Promise((resolve, reject) => {
            axios.get('grades', { params })
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        classifiers: (cntx, params) => new Promise((resolve, reject) => {
            axios.get('classifiers', { params })
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
    },
}
